export default __webpack_public_path__ + "static/media/icone.296fd04a.svg";